import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import actions from './actions';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  // strict: false,
  state: {
    accessRights: [],
    onetJobGroupSelected: {
      jobGroup: '',
    },
    currencySelected: {
      usdDivisor: 1,
      currencyCode: 'USD',
    },
    sectorSelected: {
      name: '',
    },
    sectors: [{
      name: 'Loading ...',
    }],
    countries: [],
    currencies: [],
    onetJobGroups: ['Loading...'],
    countriesSelected: [],
    minMaxJobClasses: {
      min: 0,
      max: 0,
    },
    minMaxLoading: false,
  },
  mutations,
  actions,
  getters: {},
  modules: {
  },
});
export default store;
